<div class="auth-wrapper auth-v2">
    <div class="auth-inner row m-0">
      <!-- Brand logo-->
       <a class="brand-logo" href="javascript:void(0);">
        <div>
          <img src="'../../../../../../../assets/images/pages/logo-login-page.png" class="logo" alt="brand-logo" height="300" />
          <img
            src="../assets/images/logo/smilepass.png"
            class="logo2 p-2 mt-2"
            alt="SmilePass Logo"
            
            id="main-section"
          />
        </div>
        </a
      >
      <!-- /Brand logo-->
      <!-- Left Text-->
      <div class="d-none d-lg-flex col-lg-8 align-items-center">
        <div class="w-100 d-lg-flex align-items-center justify-content-center">
          <img
            class=" banner"
            src=
              '../../../../../assets/images/pages/main-banner.jpg'
            alt="Login V2"
          />
          <div class="overlay"></div>
        </div>
      </div>
      <!-- /Left Text-->
      <!-- Login-->
      <div class="d-flex col-lg-4 align-items-center auth-bg px-2 p-lg-5 login ">
        <div class="col-12 col-sm-8 col-md-6 col-lg-12 px-xl-2 mx-auto practice-login">
          <div class="patient-login ">
            <h4 class="mb-4">Already have an account, <a routerLink="/pages/authentication/login-v2">Log in</a></h4>
          </div>
          <h2 class="card-title font-weight-bold mb-1">Create your free account</h2>
          <small class="text-muted">Use your work email to get started today!</small>
          <ngb-alert [type]="'danger'" [dismissible]="false" *ngIf="error">
            <div class="alert-body">
              <p>{{ error }}</p>
            </div>
          </ngb-alert>
  
          <form class="auth-login-form mt-2" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
            <div class="form-group">
                <label class="form-label" for="login-first-name">First Name</label>
                <input
                  type="text"
                  formControlName="firstName"
                  class="form-control"
                  [ngClass]="{ 'is-invalid': submitted && f.firstName.errors }"
                  placeholder="First Name"
                  aria-describedby="login-first-name"
                  autofocus=""
                  tabindex="1"
                />
                <div *ngIf="submitted && f.firstName.errors" class="invalid-feedback">
                  <div *ngIf="f.firstName.errors.required">First name is required</div>
                </div>
              </div>
            <div class="form-group">
                <label class="form-label" for="login-last-name">Last Name</label>
                <input
                  type="text"
                  formControlName="lastName"
                  class="form-control"
                  [ngClass]="{ 'is-invalid': submitted && f.lastName.errors }"
                  placeholder="Last Name"
                  aria-describedby="login-last-name"
                  tabindex="2"
                />
                <div *ngIf="submitted && f.lastName.errors" class="invalid-feedback">
                  <div *ngIf="f.lastName.errors.required">Last name is required</div>
                </div>
              </div>
            <div class="form-group">
              <label class="form-label" for="login-email">Work Email</label>
              <input
                type="text"
                formControlName="email"
                class="form-control"
                [ngClass]="{ 'is-invalid': submitted && f.email.errors }"
                placeholder="E-mail"
                aria-describedby="login-email"
                tabindex="3"
              />
              <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                <div *ngIf="f.email.errors.required">Email is required</div>
                <div *ngIf="f.email.errors.email">Email must be a valid email address</div>
              </div>
            </div>
            <div class="form-group">
              <div class="d-flex justify-content-between">
                <label for="login-password">Password</label
                >
              </div>
              <div class="input-group input-group-merge form-password-toggle">
                <input
                  [type]="passwordTextType ? 'text' : 'password'"
                  formControlName="password"
                  class="form-control form-control-merge"
                  [ngClass]="{ 'is-invalid error': submitted && f.password.errors }"
                  placeholder="············"
                  aria-describedby="login-password"
                  tabindex="4"
                  />
                  <div class="input-group-append">
                      <span class="input-group-text cursor-pointer"
                      ><i
                      class="feather font-small-4"
                      [ngClass]="{
                          'icon-eye-off': passwordTextType,
                          'icon-eye': !passwordTextType
                        }"
                      (click)="togglePasswordTextType()"
                      ></i
                      ></span>
                    </div>
                </div>
                <small class="text-muted">Your password must be at least 10 characters</small>
              <div
                *ngIf="submitted && f.password.errors"
                class="invalid-feedback"
                [ngClass]="{ 'd-block': submitted && f.password.errors }"
              >
                <div *ngIf="f.password.errors.required">Password is required</div>
                <!-- <div *ngIf="f.password.errors.minlength">Password must be at least 10 character long</div> -->
              </div>
            </div>
            <div class="mb-2">
                <small>By creating an account, you accept our <a href="https://smilepass.co/terms-of-service/">terms and conditions</a></small>
            </div>
            <button [disabled]="loading" class="btn btn-primary btn-block" tabindex="5" rippleEffect>
              <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>Create free account
            </button>
          </form>
          <button [disabled]="loading" class="btn btn-primary support-button" tabindex="6" >
            <img class="support-img" src="../../../../../assets/images/pages/support-img.PNG" alt="Support Image">
            &nbsp;&nbsp;Support
          </button>
        </div>
      </div>
      <!-- /Login-->
    </div>
  </div>
  